@import '../../styles/buttons.css';

:host { display: block; }

.tambr-calendar-view { display: none; }

.card tambr-calendar-card-view { display: block; }

.grid tambr-calendar-grid-view { display: block; }




.actions-container {
  margin: 10px 10px 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 35px;
  align-items: center;
}

.filter-container {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}

.filter-buttons {
  display: flex;
  gap: 5px;
  flex-wrap: wrap;
}

.filter-buttons button.tambr-stroked-button {
  height: auto;
}


.calendar-subheader {
  margin: 40px 0px 10px;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;
}

.selected-date {
  padding-left: 10px;
  flex-grow: 1;
  text-transform: uppercase;
  font-size: 13px;
  letter-spacing: 1.1px;
}

.desktop-date { display: inline; }
.mobile-date { display: none; }

@media (max-width: 450px) {
  .desktop-date { display: none; }
  .mobile-date { display: inline; }
}

.view-switch {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
}

.view-btns {
  padding-right: 10px;
  display: flex;
  gap: 15px;
}

.calendar-wrapper {
  position: relative;
}

.calendar-wrapper .loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}